
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';

interface MonthlyTrend {
    month: string;
    conversion_rate: number;
    resolution_rate: number;
    performance_rate: number;
    satisfaction_rate: number;
    reiteration_rate: number;
    procedure_rate: number | null;
    call_count: number;
}

interface UseMonthlyTrendsParams {
    projectId: number | null;
    months?: number;
    startDate?: Date | null;
    endDate?: Date | null;
}

export const useMonthlyTrends = ({
    projectId,
    months = 24,
    startDate,
    endDate
}: UseMonthlyTrendsParams) => {
    return useQuery({
        queryKey: ['monthly-trends', projectId, months, startDate, endDate],
        queryFn: async () => {
            if (!projectId) {
                console.warn('⚠️ useMonthlyTrends called with null projectId');
                return [];
            }

            const { data, error } = await supabase.rpc('get_monthly_trends', {
                p_project_id: projectId,
                p_months: months,
                p_start_date: startDate?.toISOString() || null,
                p_end_date: endDate?.toISOString() || null
            });

            if (error) {
                console.error('❌ Error fetching monthly trends:', error);
                throw error;
            }

            return data as MonthlyTrend[];
        },
        enabled: !!projectId,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};
